import React from 'react';
import { Row, Col, List } from 'reactstrap';
import PropTypes from 'prop-types';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import Body from '../Components/layout/Body';
import ReviewRow from '../Components/layout/ReviewRow';
import UpdateButton from '../Components/navigation/UpdateButton';
import { extractActivityButtons, isActivityLowTech } from './ConstActivityBtns';
import { PLATFORM_BUTTONS } from './ConstPlatformBtns';
import { ENVIRONMENT_BUTTONS } from './ConstEnvironmentBtns';
import { POSITION_BUTTONS } from './ConstBodyPositionBtns';
import { IMPORTANCE_BUTTONS } from './ConstImportanceBtns';
import { SUBTABS, GOALS_STEPS, HISTORY_STEPS, CONTEXTS_STEPS, TABS } from './ConstPaths';
import './Views.scss';

//the props should have been picked before getting to review,
//so make them all required (except name, which is always optional)
const propTypes = {
  firstName: PropTypes.string,
  mainGoal: PropTypes.string.isRequired,
  activities: PropTypes.arrayOf(PropTypes.string).isRequired,
  priority: PropTypes.string.isRequired,
  platforms: PropTypes.arrayOf(PropTypes.string).isRequired,
  environments: PropTypes.arrayOf(PropTypes.string),
  bodyPositions: PropTypes.arrayOf(PropTypes.string),
  indepSetup: PropTypes.string.isRequired,
  indepUse: PropTypes.string.isRequired,
  hasCurrentMethod: PropTypes.string.isRequired,
  currentMethods: PropTypes.arrayOf(PropTypes.object).isRequired,
  pastMethods: PropTypes.arrayOf(PropTypes.object).isRequired,
  platformsUsed: PropTypes.arrayOf(PropTypes.string).isRequired,
  // onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
};

//content sub-component with unique content for this page
function GatherInfoReviewContent(props) {
  const mainGoal = props.mainGoal;
  const activities = props.activities;
  const priority = props.priority;
  const platforms = props.platforms;
  const environments = props.environments;
  const bodyPositions = props.bodyPositions;
  const indepSetup = props.indepSetup;
  const indepUse = props.indepUse;
  const hasCurrentMethod = props.hasCurrentMethod;
  const currentMethods = props.currentMethods;
  const pastMethods = props.pastMethods;
  const platformsUsed = props.platformsUsed;

  let activityBtns = extractActivityButtons();

  const GOAL_URL = SUBTABS.GOALS + "/";
  const CONTEXTS_URL = SUBTABS.CONTEXTS + "/";
  const HISTORY_URL = SUBTABS.HISTORY + "/";

  let isLowTechPath = isActivityLowTech(priority);

  //extract the names from the method arrays, into array of strings
  const cmNames = currentMethods.map(method => method.name);
  const pmNames = pastMethods.map(method => method.name);

  const BINARY_LABELS = [ 
    {
      value: 'true',
      label: 'yes',
    },
    {
      value: 'false',
      label: 'no'
    }
  ];
  
  return(
    <>
    <Row>
    <Col>
      <div className="row aa-review-row border-top">
        <div className="col-md-1">
          <span className="fa fa-bullseye fa-3x aa-gather-color"></span>
        </div>
        <div className="col">
          <h5>Goals & Needs</h5>
          <div className="col-md-1"></div>
          <div className="col">
            <ReviewRow 
              border="none"
              padded="none"
              heading="Activities" 
              nextRoute={GOAL_URL+GOALS_STEPS.ACTIVITIES}
              values={activities}
              lookup={activityBtns}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading="Priority activity" 
              nextRoute={GOAL_URL+GOALS_STEPS.PRIORITY}
              values={priority}
              lookup={activityBtns}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading="Platforms" 
              nextRoute={GOAL_URL+GOALS_STEPS.PLATFORMS}
              values={platforms}
              lookup={PLATFORM_BUTTONS}
              skipWarning={isLowTechPath}
            />
          </div>
        </div>
      </div>
      <div className="row aa-review-row border-top">
        <div className="col-md-1">
          <span className="fa fa-users fa-2x aa-gather-color"></span>
        </div>
        <div className="col">
          <h5>Contexts</h5>
          <div className="col-md-1"></div>
          <div className="col">
            <ReviewRow 
              border="none"
              padded="none"
              heading="Environments" 
              nextRoute={CONTEXTS_URL+CONTEXTS_STEPS.ENVIRONMENTS}
              values={environments}
              lookup={ENVIRONMENT_BUTTONS}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading="Positions" 
              nextRoute={CONTEXTS_URL+CONTEXTS_STEPS.POSITIONS}
              values={bodyPositions}
              lookup={POSITION_BUTTONS}
            />
            <ReviewRowIndependence 
              border="none"
              padded="none"
              heading="Independence" 
              nextRoute={CONTEXTS_URL+CONTEXTS_STEPS.INDEPENDENCE}
              indepSetup={indepSetup}
              indepUse={indepUse}
              lookup={IMPORTANCE_BUTTONS}
            />
          </div>
        </div>
      </div>

      <div className="row aa-review-row border-top">
        <div className="col-md-1">
          <span className="fa fa-clock-o fa-3x aa-gather-color"></span>
        </div>
        <div className="col">
          {(isLowTechPath) ? 
            <h5>History of Low Tech Access</h5>
          : <h5>History of Tech Use</h5>}
          <div className="col-md-1"></div>
          <div className="col">
            <ReviewRow 
              border="none"
              padded="none"
              heading="Has a Current Method" 
              nextRoute={HISTORY_URL+HISTORY_STEPS.CURRENT}
              values={hasCurrentMethod}
              lookup={BINARY_LABELS}
            />
            {(hasCurrentMethod==='true') ? 
            <ReviewRow 
              border="none"
              padded="none"
              heading="Current Methods" 
              nextRoute={HISTORY_URL+HISTORY_STEPS.CURRENT_METHODS}
              values={cmNames}
              lookup={null}
            />
            : <span></span>}
            <ReviewRow 
              border="none"
              padded="none"
              heading="Past Methods" 
              nextRoute={HISTORY_URL+HISTORY_STEPS.PAST_METHODS}
              values={pmNames}
              lookup={null}
            />
            <ReviewRow 
              border="none"
              padded="none"
              heading="Platforms Used" 
              nextRoute={HISTORY_URL+HISTORY_STEPS.PLATFORMS}
              values={platformsUsed}
              lookup={PLATFORM_BUTTONS}
              skipWarning={isLowTechPath}
            />
          </div>
        </div>
      </div>
    </Col>
    <Col lg={2}></Col>
  </Row>
  <Row>
    <Col>
    You can Update a section if you want to make changes.  When you're done with all relevant sections, select Continue.
    </Col>
  </Row>
  </>
  );
}

//a special version of the Review Row to handle the 2 independence values
export function ReviewRowIndependence(props){
  const heading = props.heading;
  const nextRoute = props.nextRoute;
  const indepSetup = props.indepSetup;
  const indepUse = props.indepUse;
  const padded = props.padded || 'true';
  const border = props.border || 'true';
  const lookup = props.lookup;
  let cname = "";
  if(padded !== 'none')
    cname = cname + "aa-review-row";
  if(border !== 'none')
    cname = cname + " border-top";


  var indepSetupLabel;
  if(indepSetup){
    indepSetupLabel = 
    ((lookup.find(o => o.value === indepSetup)).label) + " for setup";
  }
  else{
    indepSetupLabel = "None entered for setup";
  }

  var indepUseLabel;
  if(indepUse){
    indepUseLabel = 
    ((lookup.find(o => o.value === indepUse)).label) + " for usage";
  }
  else{
    indepUseLabel = "None entered for usage";
  }

  return(
    <Row className={cname}>
      <Col>
        <Row>
          <Col>
            <strong>{heading}</strong>
          </Col>
          {nextRoute
            ? <Col>
                <UpdateButton nextRoute={nextRoute} />
              </Col>
            : <></>
          }          
        </Row>
        <Row>
          <Col>
            <List type="unstyled" className="aa-values-list">
              <li key="setup">{indepSetupLabel}</li>
              <li key="use">{indepUseLabel}</li>
            </List> 
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component.
//since the main goal step includes a form, receive the initial form values via props,
//along with setters to change those values based on the form input.
function GatherInfoReview(props) {
  const firstName = props.firstName;
  const mainGoal = props.mainGoal;
  const activities = props.activities;
  const priority = props.priority;
  const platforms = props.platforms;
  const environments = props.environments;
  const bodyPositions = props.bodyPositions;
  const indepSetup = props.indepSetup;
  const indepUse = props.indepUse;
  const hasCurrentMethod = props.hasCurrentMethod;
  const currentMethods = props.currentMethods;
  const pastMethods = props.pastMethods;
  const platformsUsed = props.platformsUsed;
  // const onContinue = props.onContinue;

  console.log("rendering GatherInfoReview, props passed in: " + JSON.stringify(props));

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "",
    pageSymbolClassName: "aa-section-symbol gather",

    title: `Review ${firstName}'s Background Info`,
    subTitle: "Here's what we've covered so far:",
    learnMore: {linkText: "",
                title: "",
                content: ""
                },
    nextRoute: TABS.EVAL, //TODO used for now instead of an onContinue callback
    sidebar: false
  }

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <GatherInfoReviewContent 
          mainGoal={mainGoal} 
          activities={activities} 
          priority={priority}
          platforms={platforms}
          environments={environments}
          bodyPositions={bodyPositions}
          indepSetup={indepSetup}
          indepUse={indepUse}
          hasCurrentMethod={hasCurrentMethod}
          currentMethods={currentMethods}
          pastMethods={pastMethods}
          platformsUsed={platformsUsed}
        />
      }
    />
    </>
  );
}

GatherInfoReview.propTypes = propTypes;
GatherInfoReview.defaultProps = defaultProps;

export default GatherInfoReview;